// removed by extract-text-webpack-plugin
module.exports = {"text":"ManageAccessKeys__text___2aI6r","tab-header":"ManageAccessKeys__tab-header___Fd02p"};